// extracted by mini-css-extract-plugin
export default {"root":"OWAi9IClb476ib4LqRS4","wrap":"PIamR81W2VQlT8MbytEH","icon":"XdLqHG2ZKh04GhKFhG6l","copy":"FSfJON4rokatXHOJ5SMw","back":"JWkLSespEHMMfoUlpD__"};